module.exports = __webpack_public_path__ + "static/media/camilo-loading.7cd9fd52.png";